import { AccordionItem, Text, List } from 'braid-design-system';
export const LimitationOfLiability = () => (
  <AccordionItem id="limitation-of-liability" label="Limitation of Liability">
    <List type="number" start={46}>
      <Text>
        Any program or content made available to you by the SEEK Group on the
        Developer Site (including, without limitation, the Data and the SEEK
        API) is provided to you on an “as is” basis and we make no
        representations about the accuracy, completeness, currency or
        suitability of such content.
      </Text>
      <Text>
        While we will use reasonable endeavours to ensure that the SEEK API is
        accessible to your Recruitment Software at all times (subject to
        standard maintenance), we make no representation that the SEEK API will
        be available on a continuous basis.
      </Text>
      <Text>
        To the extent permitted by law, the SEEK Group disclaims all liability
        for loss, damage, cost, claim or expense (including legal expense)
        whether direct or indirect (such as loss of profits, loss of opportunity
        and loss of data) incurred by you or Advertisers due to your use of the
        SEEK API, or the Data.
      </Text>
    </List>
  </AccordionItem>
);
